
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Week from '../../components/week/Week.jsx'
import EleveList from '../../components/elevelist/EleveList.jsx'
import CalendarCart from '../../components/calendarcart/CalendarCart.jsx'
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import BottomNav from '../../components/bottomnav/BottomNav.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { elevesSlice } from "../../store/elevesSlice.js";
import { formulesSlice } from "../../store/formulesSlice.js";
import { getSelectedCreneaux, getEleves } from "../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Calendar() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let selectedCreneaux = useSelector(getSelectedCreneaux);
    let reduxEleves = useSelector(getEleves);
    const lang = useSelector(getLang) //global state : language

    /*  //init global state of eleves
     let currentEleves = [
         { prenom: "Jean Sebastien", age: 56, niveau: 1, fidelite: 1, checked: true, id: 1 },
         { prenom: "Marius", age: 17, niveau: 1, fidelite: 2, checked: true, id: 2 },
         { prenom: "Elodie", age: 14, niveau: 2, fidelite: 3, checked: true, id: 3 },
         { prenom: "Thibo", age: 22, niveau: 3, fidelite: 4, checked: false, id: 4 },
     ];
 
     // set list of eleves in global state
     dispatch(elevesSlice.actions.initEleves(currentEleves)); */

    //// -- at first render :
    useEffect(() => {
        //security : redirect
        if (reduxEleves.length === 0) {
            navigate("../eleves");
        }

        // load formules from DB
        async function initFormules() { //we add this inner function to manage asynchrone
            let allFormules = await getFormules();
            dispatch(formulesSlice.actions.initFormules(allFormules)); // add formules to global state
        } //end of async function
        initFormules(); //call the inner asnchrone function
    })
    //// -- 

    async function getFormules() { // get list of formules from DB

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/formule`,
            });
            //console.log(response);
            const formules = response.data;
            return formules;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    const today = dayjs(); // set the date of the current day


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <div className="main-progress-bar">
                        <ProgressBar currentStep={3} total={5} />
                    </div>
                    <EleveList />
                    <CalendarCart />
                    <Week date={today} manager={false} />

                    <div className="bottom-nav">
                        <Button
                            className="bottom-nav-prev"
                            onClick={_ => navigate("../eleves")}
                            variant="contained">
                            <SkipPreviousIcon />{translator("Précédent", lang, "BtPrevious")}
                        </Button>

                        <Button
                            className="bottom-nav-next"
                            disabled={selectedCreneaux.length === 0}
                            onClick={_ => navigate("../infosclient")}
                            variant="contained">
                            {translator("Suivant", lang, "BtNext")} <SkipNextIcon />
                        </Button>
                    </div>

                </div>
            </main>
        </div>
    );
}

export default Calendar;